import { useSessionStore } from '@/auth/session.store';
import { ZONE_PATHS, zoneOf } from '@/auth/zone-home';

/**
 * Bu ekranlarin bulundugu bolgenin kok yolu (`/buro` ya da `/musteri`).
 *
 * Organizasyon ekranlari 2026-08-30'dan beri IKI BOLGEDE paylasiliyor (screens.ts). Ic
 * baglantilari `/buro/...` diye yazmak, musteri yoneticisini kendi bolgesinden atip
 * RequireZone'un onu geri yonlendirmesine yol aciyordu — yani baglantilar sessizce
 * calismiyordu. Yol artik cagiranin bolgesinden turetiliyor.
 *
 * Not: bolge KULLANICIDAN turetilir (zoneOf), bulunulan URL'den degil. Ikisi zaten
 * ayrisamaz — RequireZone kullaniciyi kendi bolgesi disinda birakmiyor — ve oturumdan
 * okumak, baglantiyi ureten bilesenin router konumunu bilmesini gereksiz kiliyor.
 */
export const useZoneBase = (): string => {
  const snapshot = useSessionStore((state) => state.snapshot);
  if (!snapshot) return ZONE_PATHS.customer;
  return ZONE_PATHS[zoneOf(snapshot)];
};
